import { c as _c } from "react/compiler-runtime";
import { ReserveRateProgressBarPropertiesType } from "@website/widget/reserve-rate/reserve-rate-progress-bar/reserve-rate-progress-bar.types";
import { useEffect, useRef } from "react";
export const ReserveProgressBar = t0 => {
  const $ = _c(5);
  const {
    properties
  } = t0;
  const {
    limit,
    progress
  } = properties;
  const reference = useRef(null);
  let t1;
  let t2;
  if ($[0] !== limit || $[1] !== progress) {
    t1 = () => {
      const width = Math.floor(100 / limit) * progress;
      reference?.current?.style?.setProperty("--progressWidth", `${width}%`);
    };
    t2 = [limit, progress];
    $[0] = limit;
    $[1] = progress;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="bg-on-surface-disable after:bg-on-surface-high-emphasis relative size-[4px] w-full rounded-[2px] after:absolute after:h-full after:w-[var(--progressWidth)] after:transition-colors after:content-['']" ref={reference} style={{
      transform: "translate(0, var(--progressWidth))"
    }} />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};